var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "71993C46-226D-4A41-A40C-4FB440D15B36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.1-cast-vantagem1",
    transform: "translate(-984.000000, -845.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "distribuicao",
    transform: "translate(312.000000, 717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-regular",
    transform: "translate(672.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#85CD6B",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "001-darts",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,64 C12,64 0,52 0,37.3333333 C0,22.6666667 12,10.6666667 26.6666667,10.6666667 C41.3333333,10.6666667 53.3333333,22.6666667 53.3333333,37.3333333 C53.3333333,52 41.3333333,64 26.6666667,64 Z M26.6666667,13.3333333 C13.3333333,13.3333333 2.66666667,24 2.66666667,37.3333333 C2.66666667,50.6666667 13.3333333,61.3333333 26.6666667,61.3333333 C40,61.3333333 50.6666667,50.6666667 50.6666667,37.3333333 C50.6666667,24 40,13.3333333 26.6666667,13.3333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,54.6666667 C17.0666667,54.6666667 9.33333333,46.9333333 9.33333333,37.3333333 C9.33333333,27.7333333 17.0666667,20 26.6666667,20 C36.2666667,20 44,27.7333333 44,37.3333333 C44,46.9333333 36.2666667,54.6666667 26.6666667,54.6666667 Z M26.6666667,22.6666667 C18.6666667,22.6666667 12,29.3333333 12,37.3333333 C12,45.3333333 18.6666667,52 26.6666667,52 C34.6666667,52 41.3333333,45.3333333 41.3333333,37.3333333 C41.3333333,29.3333333 34.6666667,22.6666667 26.6666667,22.6666667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,45.3333333 C22.1333333,45.3333333 18.6666667,41.8666667 18.6666667,37.3333333 C18.6666667,32.8 22.1333333,29.3333333 26.6666667,29.3333333 C31.2,29.3333333 34.6666667,32.8 34.6666667,37.3333333 C34.6666667,41.8666667 31.2,45.3333333 26.6666667,45.3333333 Z M26.6666667,32 C23.7333333,32 21.3333333,34.4 21.3333333,37.3333333 C21.3333333,40.2666667 23.7333333,42.6666667 26.6666667,42.6666667 C29.6,42.6666667 32,40.2666667 32,37.3333333 C32,34.4 29.6,32 26.6666667,32 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,38.6666667 C26.4,38.6666667 25.8666667,38.6666667 25.6,38.4 C25.0666667,37.8666667 25.0666667,37.0666667 25.6,36.5333333 L45.6,16.5333333 C46.1333333,16 46.9333333,16 47.4666667,16.5333333 C48,17.0666667 48,17.8666667 47.4666667,18.4 L27.4666667,38.4 C27.4666667,38.6666667 26.9333333,38.6666667 26.6666667,38.6666667 L26.6666667,38.6666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3333333,18.6666667 L46.6666667,18.6666667 C45.8666667,18.6666667 45.3333333,18.1333333 45.3333333,17.3333333 L45.3333333,10.6666667 C45.3333333,10.4 45.6,9.86666667 45.6,9.6 L54.9333333,0.266666667 C55.4666667,0 56,0 56.5333333,0 C57.0666667,0.266666667 57.3333333,0.8 57.3333333,1.33333333 L57.3333333,6.66666667 L62.6666667,6.66666667 C63.2,6.66666667 63.7333333,6.93333333 64,7.46666667 C64,8 64,8.53333333 63.7333333,9.06666667 L54.4,18.4 C54.1333333,18.4 53.6,18.6666667 53.3333333,18.6666667 L53.3333333,18.6666667 Z M48,16 L52.8,16 L59.4666667,9.33333333 L56,9.33333333 C55.2,9.33333333 54.6666667,8.8 54.6666667,8 L54.6666667,4.53333333 L48,11.2 L48,16 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegular);
export default __webpack_public_path__ + "static/media/ic-regular.270820937fbd445f22932a4c3c56b379.svg";
export { ForwardRef as ReactComponent };